



























import {
	Component,
	Vue
} from 'vue-property-decorator';
import {
	Instance,
} from '@/classes/TayehApi';
import BasicFormVue from './ShopInventoryCreateProductForms/CreateProductBasicForm.vue';
@Component({
	components: {
		'basic-form': BasicFormVue,
		'feature-form': () => import('./ShopInventoryCreateProductForms/CreateProductFeatureForm.vue'),
		'price-form': () => import('./ShopInventoryCreateProductForms/CreateProductPricingForm.vue'),
		'media-form': () => import('./ShopInventoryCreateProductForms/CreateProductMediaForm.vue')
	},
})
export default class ShopInventoryCreateProductForm extends Vue {

	private active_tab = 'product-info';
	private product: any = null;
	private instance_id = Number(this.$route.params.instance);

	handleCreated() {			
		this.$store.commit("setUpdateInventory");
		this.$emit("updated");
		this.$router.replace({name: 'shop-inventory', params: {instance_id: String(this.instance_id)}})
	}

	handleUpdated() {
		this.$store.commit("setUpdateInventory");
		this.$emit("updated");
		this.$router.replace({name: 'shop-inventory', params: {instance_id: String(this.instance_id)}})
	}

	async created() {
		const product = this.$route.params.product
		if (typeof product !== 'undefined') {
			try {
				let res = await Instance.getInstanceProductInfo(this.instance_id, product, {
					get_filters: true,
					get_categories: true
				});
				this.product = res.data;
			} catch (err) {
				console.error("GET PRODUCT", err);
				// this.$router.back();
			}
		} else {
			this.product = {}
		}
	}
}
